/**
 * Clave de alta de un formulario nuevo.
 *
 * Se genera una por formulario (no por request) y viaja en todos los POST de alta que salgan de
 * él. El backend crea un solo documento por clave: si el autoguardado y «Guardar» salen casi a la
 * vez —el segundo arranca antes de que el primero conteste, así que todavía no hay `_id`— el
 * segundo recibe el documento del primero en vez de crear otro.
 */
export function newClientCreateKey() {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch (e) {
    /* sin crypto.randomUUID: cae al generador de abajo */
  }
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export default newClientCreateKey;
